import { environment } from "../../../environments/environment";
import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { Utenteservice } from "../utente.service";



export const formSalvataggioModello : AnaColumn[] =[
    {
      itemType:"group",caption:'', class: '', colCount: "1", data:[
        
        {
          type: 'campo', colVisible: false, dataField: "nomeModello", dataType: "", caption: "Nome Modello",
          width: "400", maxLength: "100", maxSize: 12, defaultValue:'',validation: [{ type: "required", message: "Campo Obbligatorio" }]
          
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, caption: "" },

        {
          type: 'campoComponent', dataField: "categoriaModello", dataType: "", caption: "Categorie Modello",validation: [{ type: "required", message: "Campo Obbligatorio" }],
          colVisible: false,
          labelVisible: false,
          labelPosition: "top",
          disableOnUpdate: true,
          dynamic: {
            dataSource: 'CategoriaModello',
            autocomplete: false,
            checkValue: {
              checkValueMessage: '',
              forceInsert: false
            },
            valueExpr: '',
            displayExpr: 'descrizione',
            caption: "",
            filter: '/',
            componentType: 'dynamicList',
            enableEditor:  {
              add:true,
              remove:true,
              update:true
            },
            campiVista: ['descrizione'],
            settingList: {
              scrollingEnabled: true,
              selectionMode: 'single',
              showSelectionCheckBox: true,
              showScrollbar: 'onHover',
              keyExpr: 'id',
              width: 40 * aspect,
              height: 150
            }
      
          }
      
        }
         
        ]
      }
        
 
  
  
  ];

